var map = {
	"./Awareness 1.jpg": 1834,
	"./Awareness 2.jpg": 9685,
	"./Awareness 3.jpg": 2072,
	"./Awareness 4.jpg": 3659,
	"./Awareness 5.jpg": 2350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4461;